export default "__VITE_ASSET__SACOEEcv__"